import React from 'react';
import PostCard from './PostCard';

const PostSection = () => {
  return (
    <div className="flex md:gap-8">
      <PostCard value={'?name=linkedIn'} image={'/socialmedialinkedin.png'} />
      <PostCard value={'?name=x'} image={'/socialmediax.png'} />
    </div>
  );
};

export default PostSection;
